import { useEffect, useState, useCallback } from "react";
import { getMDMDocuments } from "../../utils/ConstantsURL";

export const useFetchMDMDocuments = (token) => {
  const [mdmDocuments, setMDMDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response = await fetch(getMDMDocuments(), {
        method: "GET",
      });

      let data = await response.json();
      if (response.ok) {
        setMDMDocuments(data);
        setLoading(false);
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { mdmDocuments, loading, refetch: fetchData };
};
